import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const TestPage = () => {
  const [sessionId, setSessionId] = useState('test-' + new Date().getTime());
  const [testResults, setTestResults] = useState([]);
  
  // Function to test the API endpoints
  const runTests = async () => {
    // Clear previous results
    setTestResults([]);
    addTestResult('Starting tests with session ID: ' + sessionId);
    
    // Test the root endpoint
    try {
      const response = await axios.get(`${API}/`);
      addTestResult('Root API test: ' + JSON.stringify(response.data));
    } catch (error) {
      addTestResult('Root API test error: ' + error.message);
    }
    
    // Test the provider switching
    try {
      const response = await axios.post(`${API}/provider/switch`, {
        provider: 'gemini',
        model: 'gemini-2.0-flash',
        session_id: sessionId
      });
      addTestResult('Provider switch test: ' + JSON.stringify(response.data));
    } catch (error) {
      addTestResult('Provider switch test error: ' + error.message);
    }
    
    // Test sending a message
    try {
      const response = await axios.post(`${API}/conversation/message`, {
        content: 'Hello from test page',
        session_id: sessionId,
        provider: 'gemini'
      });
      addTestResult('Send message test: ' + JSON.stringify(response.data));
    } catch (error) {
      addTestResult('Send message test error: ' + error.message);
    }
    
    // Test getting conversation
    try {
      const response = await axios.get(`${API}/conversation/${sessionId}`);
      addTestResult('Get conversation test: ' + JSON.stringify(response.data));
    } catch (error) {
      addTestResult('Get conversation test error: ' + error.message);
    }
  };
  
  // Helper function to add test results
  const addTestResult = (result) => {
    setTestResults(prevResults => [...prevResults, {
      id: prevResults.length + 1,
      timestamp: new Date().toISOString(),
      result
    }]);
  };
  
  return (
    <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto', background: '#f5f5f5', borderRadius: '8px' }}>
      <h1>Galactus 3 API Test Page</h1>
      <button
        style={{ padding: '0.75rem 1rem', background: '#6d28d9', color: 'white', border: 'none', borderRadius: '0.5rem', cursor: 'pointer', marginBottom: '2rem' }}
        onClick={runTests}
      >
        Run API Tests
      </button>
      
      <div style={{ background: 'white', padding: '1rem', borderRadius: '0.5rem', border: '1px solid #ddd' }}>
        <h2>Test Results:</h2>
        {testResults.length === 0 ? (
          <p>No tests run yet. Click the button above to start testing.</p>
        ) : (
          <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
            {testResults.map(test => (
              <div key={test.id} style={{ borderBottom: '1px solid #eee', padding: '0.75rem 0' }}>
                <div style={{ fontSize: '0.8rem', color: '#666' }}>
                  {new Date(test.timestamp).toLocaleTimeString()}
                </div>
                <pre style={{ margin: '0.5rem 0', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                  {test.result}
                </pre>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TestPage;
